import React, { useEffect, useState } from "react";
import Tabs from "components/Tabs";
import Header from "components/Header";
import { useTranslation } from "react-i18next";
import { GET_UPCOMING_BOOKINGS_WHIT_CODE_AND_EMAIL } from "graphql/queries/stays";
import { getStaysData, setStaysData } from "actions/stays";
import { getUserData } from "actions/user";
import { getHotel } from "actions/hotel";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { UseStayBookings } from "graphql/stays";
import { Redirect } from "react-router-dom";

const AddStay = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const staysData = useSelector(getStaysData);
    const user = useSelector(getUserData);
    const hotel = useSelector(getHotel);
    const [email, setEmail] = useState(user?.email ?? "");
    const [code, setCode] = useState("");
    const [redirectTo, setRedirectTo] = useState("");

    const tabBar = document.getElementsByClassName("tab-bar");
    console.log(tabBar);
    const { data, query } = UseStayBookings(GET_UPCOMING_BOOKINGS_WHIT_CODE_AND_EMAIL);

    function SearchStayBooking() {
        if (staysData && staysData.includes(code)) {
            toast(t("code-already-exist"));
            setRedirectTo("/stays");
        } else {
            query({ email: email, codes: [code] });
        }
    }

    useEffect(() => {
        if (data?.results.length > 0) {
            if (staysData) {
                dispatch(setStaysData({ user: user?.ref ?? "any", values: [...staysData, data?.results[0].code] }));
            } else {
                dispatch(setStaysData({ user: user?.ref ?? "any", values: [data.results[0].code] }));
            }
            if (data?.results[0]?.state == "COMPLETED") {
                setRedirectTo("/stays");
            } else {
                setRedirectTo("/stays/status=upcoming");
            }
        } else if (data?.results.length === 0) {
            toast(t("incorrect-email-or-code"));
        }
    }, [data]);

    useEffect(() => {
        if (!hotel) {
            setRedirectTo("/site");
        }
    }, [hotel]);

    if (redirectTo) {
        return <Redirect push to={redirectTo} />;
    }
    return (
        <section className="basic has-tabs has-top">
            <Header title={t("add-booking")} />
            <section className=" h-screen">
                <div className=" h-full">
                    <span className={"float-left font-medium text-sm  "}>{t("email")}</span>
                    <input
                        type="text"
                        name="email"
                        id="input-email"
                        value={email}
                        placeholder={t("email-example")}
                        onChange={(e) => {
                            setEmail(e.target.value.toLowerCase());
                        }}
                    />
                    <span className={"float-left font-medium text-sm mt-4"}>{t("booking-code")}</span>
                    <input
                        type="text"
                        name="code"
                        value={code}
                        id="input-code"
                        placeholder={t("code-example")}
                        onChange={(e) => {
                            setCode(e.target.value);
                        }}
                    />
                    <div
                        className="w-full flex justify-center items-center absolute "
                        style={{ bottom: "75px", left: "0" }}
                    >
                        <button
                            id="add-booking-button"
                            style={{
                                maxWidth: "32rem",
                            }}
                            className=" left-0 rounded w-full font-bold text-xl py-2 bg-accent text-accent-contrast mx-2"
                            onClick={SearchStayBooking}
                        >
                            {t("add")}
                        </button>
                    </div>
                </div>
            </section>
            <Tabs />
        </section>
    );
};

export default AddStay;
